import React from 'react';

const CustomTimePicker = ({ value, onChange, className, name }) => {
  // Parse the time value (HH:mm format)
  const parseTime = (timeString) => {
    if (!timeString) return { hour: 8, minute: 0, period: 'AM' };
    const [hours, minutes] = timeString.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;
    return { hour: hour12, minute: minutes, period };
  };

  // Convert 12-hour format back to 24-hour format
  const formatTo24Hour = (hour12, minute, period) => {
    let hour24 = parseInt(hour12);
    if (period === 'PM' && hour24 !== 12) hour24 += 12;
    if (period === 'AM' && hour24 === 12) hour24 = 0;
    return `${hour24.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
  };

  const { hour, minute, period } = parseTime(value);

  const handleChange = (type, newValue) => {
    let newHour = hour;
    let newMinute = minute;
    let newPeriod = period;

    if (type === 'hour') newHour = parseInt(newValue);
    if (type === 'minute') newMinute = parseInt(newValue);
    if (type === 'period') newPeriod = newValue;

    const time24 = formatTo24Hour(newHour, newMinute, newPeriod);
    onChange({ target: { value: time24, name } });
  };

  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        {/* Hour Select */}
        <select
          value={hour}
          onChange={(e) => handleChange('hour', e.target.value)}
          className="w-16 appearance-none rounded-md border border-[#DFDFDF] bg-white p-[10px] text-center font-semibold text-[#545454] focus:outline-none focus:ring-0"
        >
          {[...Array(12)].map((_, i) => {
            const h = i + 1;
            return (
              <option key={h} value={h}>
                {h.toString().padStart(2, '0')}
              </option>
            );
          })}
        </select>

        <span className="text-lg font-semibold text-[#545454]">:</span>

        {/* Minute Select */}
        <select
          value={minute}
          onChange={(e) => handleChange('minute', e.target.value)}
          className="w-16 appearance-none rounded-md border border-[#DFDFDF] bg-white p-[10px] text-center font-semibold text-[#545454] focus:outline-none focus:ring-0"
        >
          {[...Array(60)].map((_, i) => (
            <option key={i} value={i}>
              {i.toString().padStart(2, '0')}
            </option>
          ))}
        </select>

        {/* AM/PM Select */}
        <select
          value={period}
          onChange={(e) => handleChange('period', e.target.value)}
          className="w-16 appearance-none rounded-md border border-[#DFDFDF] bg-white p-[10px] text-center font-semibold text-[#545454] focus:outline-none focus:ring-0"
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    </div>
  );
};

export default CustomTimePicker;
